<template>
    <div>
  
      <section class="content">
        <div class="box info-box">
          <div class="box-header with-border">
            Filter By
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
                <label for="Branch">Branch</label>
                <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchWiseRecord(branch)"></v-select>
                
                <has-error
                  :form="form"
                  field="branch_id"
                ></has-error>
              </div>
              <div class="col-md-3">
                <label for="date">Payment Date</label>
                <input type="date" v-model="date" name="date" class="form-control" @change="changeFilter()" placeholder="Date">
            </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
  
        <!-- Default box -->
        <div class="info-box"  v-if="canAccess('branch-center-view-any')">
          <div class="box-header with-border">
            <h3 class="box-title">History</h3>
            
            <div class="box-tools">
              <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('branch-center-create')">
                <i class="fa fa-plus"></i> Add New
              </button> -->
            </div>
  
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <label>
                  <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
              <div class="col-sm-6 col-xs-6">
                <div class="input-group pull-right input-group-sm" style="width: 150px;">
                  <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">
  
                  <div class="input-group-btn">
                    <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <table class="table table-sm table-bordered table-hover">
              <thead style="background-color: #d6dddd;">
                <tr>
                  <th class="hidden-xs">Sr. No.</th>
                  
                  <th>Member </th>
                  <th class="hidden-xs">ApplicationNo</th>
                  <th class="hidden-xs">Method</th>
                  <th class="hidden-xs">Relation Type</th>
                  <th class="hidden-xs">Title</th>
                  <th class="hidden-xs">Branch</th>
                  <th class="hidden-xs">Created At</th>
                  <th>Action </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in rows.data" :key="index">
                  <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                  <td><span v-if="row.member">{{ row.member.name }} <br> <i class="text-info">{{ row.member.code }}</i></span></td>
                  
                  <td class="hidden-xs"><span v-if="row.member_loan_plan">
                    <router-link :to="/loanDetail/ + row.member_loan_plan.id + '/' + row.disbursement_id" ><i class="fa fa-tasks"> {{ row.member_loan_plan.applicationNo }}</i></router-link>
                    </span>
                  </td>
                  <td class="hidden-xs">{{ row.method }}</td>
                  <td class="hidden-xs">{{ row.relation_type }}</td>
                  <td class="hidden-xs">{{ row.title }}</td>
                  <td class="hidden-xs">{{ row.branch.name }}</td>
                  <td class="hidden-xs">{{ row.created_at }}</td>
                  <td>
                    <div class="btn-group dropup">
                      <button type="button" class="btn btn-flat btn-xs dropdown-toggle" data-toggle="dropdown">
                        Task <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-right" role="menu">
                        <li v-if="canAccess('branch-center-view')">
                          <a @click="viewModal(row)">
                            <i class="fa fa-eye"></i> View
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
                  
          </div>
          <!-- /.box-body -->
          <div class="box-footer clearfix" v-if="pagination.current_page > 0">
            <div class="row">
              <div class="col-sm-4">
                Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
              </div>
              <div class="col-sm-8">
                <ul class="pagination pagination-sm no-margin pull-right">
                  <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                  <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>
  
                  <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                  <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                  <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                  <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                  <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                  <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                  <li><a href="#">...</a></li>
                  
                  <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                  <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                  <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>
  
                  <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                  <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- /.box -->
  
      </section>
          <!-- /.modal -->
          <div class="modal fade" id="viewModal">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header bg-aqua">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Details</h4>
                </div>
                <div class="modal-body">
                  <!-- right column -->
                  <div class="row">
                    <div class="col-md-6">
                      <!-- Profile Image -->
                      <div class="card card-primary card-outline">
                        <div class="card-body box-profile">
                          <ul class="list-group mb-3">
                            <li class="list-group-item">
                              <b>Branch </b>
                                <a
                                  class="pull-right"
                                  v-if="record.branch"
                                  >{{ record.branch.name }}</a
                                >
                            </li>
                            <li class="list-group-item">
                              <b>Member </b>
                                <a
                                  class="pull-right"
                                  v-if="record.member"
                                  >{{ record.member.name }}</a
                                >
                            </li>
                            <li class="list-group-item">
                              <b>Member Code</b>
                                <a
                                  class="pull-right"
                                  v-if="record.member"
                                  >{{ record.member.code }}</a
                                >
                            </li>
                            <li class="list-group-item">
                              <b>Application No</b>
                                <a
                                  class="pull-right"
                                  v-if="record.member_loan_plan"
                                  >{{ record.member_loan_plan.applicationNo }}</a
                                >
                            </li>
                            <!-- <li class="list-group-item">
                              <b>remark Name</b>
                              <a class="pull-right">{{ record.remark }}</a>
                            </li> -->
                          </ul>
                        </div>
                        <!-- /.card-body -->
                      </div>
                      <!-- /.card -->
                    </div>
                    <!-- /.col -->
                    <div class="col-md-6">
                      <!-- Profile Image -->
                      <div class="card card-primary card-outline">
                        <div class="card-body box-profile">
                          <ul class="list-group mb-3">
                            
                          </ul>
                        </div>
                        <!-- /.card-body -->
                      </div>
                      <!-- /.card -->
                    </div>
                    <!-- /.col -->
                  </div>
                </div>
                <div class="modal-footer text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                  >
                    CLOSE
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </div>
          <!-- /.modal -->
  
  
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import GetBranch from '../../mixins/BranchRecords'
  export default {
    name: 'loanhistory',
    computed: {
      ...mapState([
        'user'
      ])
    },
    mixins: [GetBranch],
    data () {
      return {
        pagination: {
          current_page: 0,
          from: 0,
          to: 0,
          total: 0,
          last_page: 0,
          per_page: 0,
          first_page_url: null,
          last_page_url: null,
          next_page_url: null,
          prev_page_url: null,
          path: null
        },
        per_page: 10,
        table_search: '',
        form: new Form({
          id: '',
          branch_id: '',
          description: '',
          name: '',
          remark: '',
          status: ''
        }),
        editMode: false,
        branches: [],
        branch: {},
        officers: {},
        rows: [],
        record: {},
        response: {},
        date: '',
        withChangeFilter: true
      }
    },
    methods: {
      canAccess (perm) {
        return this.$store.state.permissions.includes(perm)
      },
      getBranchWiseRecord (branch) {
        this.form.branch_id = branch.id
        this.changeFilter()
      },
      newModal () {
        this.editMode = false
        this.form.reset()
        $('#newModal').modal({backdrop: 'static', keyboard: false})
      },
      editModal (row) {
        this.editMode = true
        this.form.reset()
        $('#newModal').modal({backdrop: 'static', keyboard: false})
        this.form.fill(row)
      },
      viewModal (row) {
        this.record = {}
        this.response = {}
        this.editMode = false
        this.form.reset()
        this.record = row
        this.response = JSON.parse(row.response)
        $('#viewModal').modal({backdrop: 'static', keyboard: false})
        // this.form.fill(row)
      },
      changeFilter (page = null, pg = null) {
        var c = JSON.parse(localStorage.user)
        var pageUrl = ''
        if (this.pagination.first_page_url && pg === 'first') {
          pageUrl += this.pagination.first_page_url
        } else if (this.pagination.last_page_url && pg === 'last') {
          pageUrl += this.pagination.last_page_url
        } else if (this.pagination.next_page_url && pg === 'next') {
          pageUrl += this.pagination.next_page_url
        } else if (this.pagination.prev_page_url && pg === 'prev') {
          pageUrl += this.pagination.prev_page_url
        } else if (this.pagination.path != null) {
          pageUrl += this.pagination.path
        } else {
          pageUrl += 'loanhistory'
        }
  
        if (pg == null) {
          pageUrl += `?per_page=${this.per_page}`
        } else {
          pageUrl += `&per_page=${this.per_page}`
        }
        if (c.type !== 'admin') {
          if (c.role.name === 'Manager') {
            pageUrl += `&branch_id=${c.agent_profile.branch_id}`
          } else {
            pageUrl += `&agent_id=${c.id}`
          }
        }
        if (c.type === 'admin') {
          if (this.form.branch_id) {
            pageUrl += `&branch_id=${this.form.branch_id}`
          }
        }
        if (this.date) {
          pageUrl += `&date=${this.date}`
        }
        if (this.table_search) {
          pageUrl += `&searchTerm=${this.table_search}`
        }
        if (page != null) {
          pageUrl += `&page=${page}`
        }
        this.$axios
          .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
          .then((data) => {
            console.log(data)
            this.rows = data.data
            this.pagination = data.data
          }).catch(function (error) { console.log(error) })
      }
    },
    created () {
      // this.loadData()
      this.changeFilter()
      this.getBranch()
      Fire.$on('AfterCreate', () => {
        // this.loadData()
        this.changeFilter()
      })
    }
  }
  </script>
  <style scoped>
  .red {
    color: red;
  }
  .content {
    padding: 0px;
  }
  .info-box {
      border-radius:10px;
      box-shadow: 0px 0px 4px gray;
    }
    .box-footer {
      border-radius:0px 0px 10px 10px;
    }
  </style>



// WEBPACK FOOTER //
// LoanHistory.vue?4e40c710